// Modules
import Box from '@mui/material/Box';
import React from 'react';
import Typography from "../../atoms/Typography";
import HtmlRenderer from "../../atoms/HtmlRenderer";

// Styles
import colors from "../../theme/colors";
import { renderIcon } from "../EStoreProduct/ProductItem";
import { checkLocaleHkTw } from "../EStoreBestsellerHome/PopularCard";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const RelatedGameCard = props => {
  const {
    mainImageNext,
    mainImage = '',
    title = '',
    href = "/",
    nextLink,
    listIcon,
    valuePrice,
    isMerchandise = false,
    locale,
    titleSale
  } = props;
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      backgroundColor: colors.primary.bandaiNamcoWhite,
      borderRadius: '20px',
      overflow: 'hidden',
      width: "100%",
      transform: 'rotate(0)',
      maxWidth: {
        xs: '311px',
        md: '357px'
      },
      height: '100%',
      display: "flex",
      flexDirection: "column",
      border: "1px solid",
      borderColor: colors.neutral.neutral6
    },
    children: [/*#__PURE__*/_jsx(Box, {
      sx: {
        maxWidth: '100%',
        position: 'relative',
        paddingBottom: '56.1%',
        overflow: 'hidden',
        borderRadius: '20px 20px 0 0',
        "& a": {
          height: "100% !important",
          width: "100% !important",
          lineHeight: "0px",
          textDecoration: "none"
        },
        "& span": {
          height: "100% !important",
          width: "100% !important"
        }
      },
      children: typeof nextLink === "function" ? nextLink?.(href, /*#__PURE__*/_jsx(Box, {
        sx: {
          position: "absolute",
          top: "0px",
          left: "0px",
          width: "100%",
          height: "100%",
          background: "#F6F6F6",
          '& img': {
            objectFit: 'cover',
            borderRadius: '20px 20px 0 0',
            display: 'block',
            width: '100%',
            height: '100%',
            transform: "scale(1)",
            transition: "all 0.3s ease-in-out",
            maxHeight: {
              xs: '177px',
              md: '203px'
            },
            overflow: 'hidden',
            "&:hover": {
              transform: "scale(1.2)"
            }
          }
        },
        children: mainImageNext || /*#__PURE__*/_jsx("img", {
          src: mainImage,
          alt: title ?? ''
        })
      })) : /*#__PURE__*/_jsx(Box, {
        sx: {
          position: "absolute",
          top: "0px",
          left: "0px",
          width: "100%",
          height: "100%",
          '& img': {
            objectFit: 'cover',
            borderRadius: '20px 20px 0 0',
            display: 'block',
            width: '100%',
            height: '100%',
            transform: "scale(1)",
            transition: "all 0.3s ease-in-out",
            maxHeight: {
              xs: '177px',
              md: '203px'
            },
            overflow: 'hidden',
            "&:hover": {
              transform: "scale(1.2)"
            }
          }
        },
        children: mainImageNext || /*#__PURE__*/_jsx("img", {
          src: mainImage,
          alt: title ?? ''
        })
      })
    }), /*#__PURE__*/_jsxs(Box, {
      sx: {
        height: "inherit",
        display: "flex",
        flexDirection: "column",
        padding: {
          xs: '24px 28px 32px',
          md: '28px 32px 36px'
        },
        "& a": {
          textDecoration: "none"
        }
      },
      children: [typeof nextLink === "function" ? nextLink?.(href, /*#__PURE__*/_jsx(Typography, {
        variant: "p3",
        sx: {
          color: colors.primary.bandaiNamcoBlack,
          display: '-webkit-box',
          WebkitBoxOrient: 'vertical',
          WebkitLineClamp: 2,
          overflow: 'hidden'
        },
        children: /*#__PURE__*/_jsx(HtmlRenderer, {
          component: "div",
          value: title
        })
      })) : /*#__PURE__*/_jsx(Typography, {
        variant: "p3",
        sx: {
          color: colors.primary.bandaiNamcoBlack,
          display: '-webkit-box',
          WebkitBoxOrient: 'vertical',
          WebkitLineClamp: 2,
          overflow: 'hidden'
        },
        children: /*#__PURE__*/_jsx(HtmlRenderer, {
          component: "div",
          value: title
        })
      }), !!listIcon?.length && !isMerchandise && /*#__PURE__*/_jsx(Box, {
        sx: {
          paddingTop: "8px",
          display: "flex",
          gap: {
            xs: "10px",
            md: "14px"
          },
          flexWrap: "wrap",
          alignItems: "center",
          "& svg": {
            "& path": {
              fill: "#9F9F9F"
            }
          }
        },
        children: listIcon?.map((item, index) => {
          return /*#__PURE__*/_jsx(React.Fragment, {
            children: renderIcon(item)
          }, index);
        })
      }), /*#__PURE__*/_jsxs(Box, {
        sx: {
          display: "flex",
          marginTop: "auto",
          paddingTop: "8px"
        },
        children: [!(checkLocaleHkTw(locale) || locale === "ko-kr") && /*#__PURE__*/_jsx(Typography, {
          color: colors.neutral.neutral2,
          sx: {
            fontSize: "10px",
            lineHeight: "14px",
            marginRight: "8px"
          },
          children: valuePrice?.label
        }), /*#__PURE__*/_jsxs(Box, {
          sx: {
            display: "flex",
            flexDirection: "column",
            height: {
              xs: "36px",
              md: "48px"
            }
          },
          children: [/*#__PURE__*/_jsxs(Box, {
            sx: {
              display: "flex",
              alignItems: checkLocaleHkTw(locale) || locale === "ko-kr" ? "flex-end" : "flex-start"
            },
            children: [/*#__PURE__*/_jsx(Typography, {
              variant: "h6",
              children: valuePrice?.price
            }), (checkLocaleHkTw(locale) || locale === "ko-kr") && /*#__PURE__*/_jsx(Typography, {
              color: colors.neutral.neutral2,
              sx: {
                fontSize: "10px",
                lineHeight: "14px",
                marginLeft: "8px",
                marginBottom: {
                  xs: "2px",
                  md: "4px"
                }
              },
              children: valuePrice?.label
            })]
          }), /*#__PURE__*/_jsxs(Box, {
            sx: {
              display: "flex",
              alignItems: "center"
            },
            children: [/*#__PURE__*/_jsx(Typography, {
              variant: "l2",
              color: colors.neutral.neutral2,
              sx: {
                textDecorationLine: "line-through"
              },
              children: valuePrice?.priceOld
            }), titleSale && /*#__PURE__*/_jsx(Typography, {
              variant: "p7",
              color: colors.neutral.neutral2,
              sx: {
                color: "#DF4662",
                marginLeft: "4px",
                fontSize: {
                  xs: "10px",
                  md: "12px"
                },
                lineHeight: {
                  xs: "12px",
                  md: "18px"
                },
                textTransform: "lowercase"
              },
              children: titleSale
            })]
          })]
        })]
      })]
    })]
  });
};
export default /*#__PURE__*/React.memo(RelatedGameCard);